/* eslint-disable react/prop-types */
import React from 'react'
import { Pressable, StyleSheet, View, Text } from 'react-native'
import { commonStyle } from '../../assets/TextStyles/TextStyles'
import confirm from '../../assets/sounds/confirm.mp4'
import { playSound } from '../../utils/AudioPlayer'

const Button = (props) => {
  const baseColor = 'baseColor' in props ? props.baseColor : '#24a698'
  const hoverColor = 'hoverColor' in props ? props.hoverColor : '#2ed3c2'

  const handleOnPress = () => {
    playSound(confirm)
    props.onPress()
  }

  return (
      <View style={[styles.container, commonStyle.corner, { pointerEvents: props.Title !== undefined ? 'auto' : 'none' }]}>
        <Pressable onPress={handleOnPress}
          style={({ hovered, pressed }) => [props.style, commonStyle.corner, styles.wrapperCustom, { backgroundColor: hovered | pressed ? baseColor : hoverColor }]}>
          <Text style={styles.text} >{props.Title}</Text>
        </Pressable>
      </View>
  )
}

const styles = StyleSheet.create({
  container: {
    minWidth: 120
  },
  text: {
    textAlign: 'center',
    fontSize: 18,
    userSelect: 'none'
  },
  wrapperCustom: {
    padding: 6,
    paddingLeft: 20,
    paddingRight: 20,
    height: 45,
    justifyContent: 'center',
    userSelect: 'none'
  }
})

export default Button
